import { render, staticRenderFns } from "./CarouselPrescriber.vue?vue&type=template&id=e9218b00&scoped=true&"
import script from "./CarouselPrescriber.vue?vue&type=script&lang=ts&"
export * from "./CarouselPrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./CarouselPrescriber.vue?vue&type=style&index=0&id=e9218b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9218b00",
  null
  
)

export default component.exports